import { render, staticRenderFns } from "./kolAudit.vue?vue&type=template&id=2fa1642d&scoped=true&"
import script from "./kolAudit.vue?vue&type=script&lang=js&"
export * from "./kolAudit.vue?vue&type=script&lang=js&"
import style0 from "./kolAudit.vue?vue&type=style&index=0&id=2fa1642d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1642d",
  null
  
)

export default component.exports